export function parseBooleanFlag(
  rawValue: string | undefined,
  fallback: boolean,
): boolean {
  if (!rawValue) return fallback

  const normalized = rawValue.trim().toLowerCase()

  if (
    normalized === '1' ||
    normalized === 'true' ||
    normalized === 'yes' ||
    normalized === 'on'
  ) {
    return true
  }

  if (
    normalized === '0' ||
    normalized === 'false' ||
    normalized === 'no' ||
    normalized === 'off'
  ) {
    return false
  }

  return fallback
}
